
import { threeFonts, loadFontGlyphs } from '../../../3dapps/js/fontManage'
import * as THREE from 'three'
require('three-orbitcontrols');

export let scene;
export let camera;
export let renderer;
export let currentModel;
export let renderCount = -600;
export let controls;
let scale;
let textSize; // 原始的尺寸
let grid;

const material = new THREE.MeshPhongMaterial({
    reflectivity: 1,
});

function incRenderCount() {
    renderCount += 2;
}

function setCount(count) {
    renderCount = count;
}

export function initThree(canvas) {
    let canvas_bound = canvas.getBoundingClientRect();
    scene = new THREE.Scene(); //相机

    //创建3D世界
    let w = canvas_bound.width;
    let h = canvas_bound.height;

    //创建渲染器
    renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true, //抗锯齿
        preserveDrawingBuffer: true, //3D加上这个在缩略图中可以变成白色
    });
    renderer.setSize(w, h);
    renderer.setClearColor(new THREE.Color("#ffffff")); //把渲染器的背景变成白色
    renderer.setPixelRatio(2);


    // 创建场景
    // 量纲，单位 1px 1m 1kg
    camera = new THREE.PerspectiveCamera(50, w / h, 0.1, 42000);
    //定义相机的x,y,z位置
    camera.position.set(64.78358759811756, 286.9691109606036, 557.918415861498);
    camera.lookAt(scene.position); //把相机的位置渲染到场景中

    //控制器，鼠标左键和右键，滑轮操作
    controls = new THREE.OrbitControls(camera, canvas);
    //是否可以缩放
    controls.enableZoom = true;
    //设置相机距离原点的最远距离
    controls.minDistance = 20;
    controls.maxDistance = 10000;

    // 538.8709819791578 376.7355646246013 240.1840526092461
    controls.addEventListener("change", function () {
        renderCount += 2;
        // console.log(camera.position.x, camera.position.y, camera.position.z);
    });

    // 灯光
    function addLights() {
        // 平行光
        let dirLight = new THREE.DirectionalLight(0xffffff, 0.5);
        dirLight.position.set(-30, 30, -30); //注意：位置一定要调整好，否则会出现物体变成黑色的情况
        scene.add(dirLight);

        let dirLight2 = new THREE.DirectionalLight(0xffffff, 0.5);
        dirLight2.position.set(30, 30, 50);
        scene.add(dirLight2);

        // 环境光
        let ambientLight = new THREE.AmbientLight(0xffffff, 0.3);
        scene.add(ambientLight);

        // 网格灯光
        // const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444);
        // hemiLight.position.set(0, 20, 0);
        // scene.add(hemiLight);

        const dirLight3 = new THREE.DirectionalLight(0xffffff);
        dirLight3.position.set(0, 0.1, 0);
        scene.add(dirLight3);
    }
    addLights();

    // scene.background = new THREE.Color(0xe0e0e0);
    // scene.fog = new THREE.Fog(0xe0e0e0, 20, 1200);

    // const floor = new THREE.Mesh(new THREE.PlaneGeometry(2000, 2000), new THREE.MeshPhongMaterial({ color: 0x999999, depthWrite: false }));
    // floor.rotation.x = - Math.PI / 2;
    // floor.position.y = -10;
    // scene.add(floor);

    grid = new THREE.GridHelper(1200, 15, 0x000000, 0x000000);
    grid.material.opacity = 0.2;
    grid.material.transparent = true;
    scene.add(grid);
    grid.position.y = -1.5;

    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderCount++;


    //渲染场景
    function animate() {
        requestAnimationFrame(animate);
        if (renderCount > 0) {
            renderer.render(scene, camera);
            renderCount = 0;
        }
        else if (renderCount < 0) {
            renderer.render(scene, camera);
            renderCount++;
        }
    }
    animate();
}

export function updateModel(vue, fontName, text, lineHeight, rotateAngle) {

    return loadFontGlyphs(vue, fontName, text).then(() => {
        let data = initTextData(fontName, text);
        let center = data.box.getCenter();
        textSize = data.box.getSize();
        scale = lineHeight / textSize.y;
        let geom = addRotatePoly2(data, rotateAngle, scale);
        let mesh = new THREE.Mesh(geom, material);



        mesh.position.x = -center.x * scale;
        mesh.position.z = center.y * scale;
        mesh.rotation.x = -0.5 * Math.PI;
        mesh.scale.set(scale, scale, scale);
        scene.add(mesh);

        if (currentModel) {
            scene.remove(currentModel);
            currentModel.geometry.dispose();
            currentModel = null;
        }

        currentModel = mesh;
        incRenderCount();
        return currentModel;
    });
}

// 文本，计算必要的多边形数据，为旋转做准备。 
function initTextData(fontName, text) {
    // 获取threejs字体
    let font = threeFonts[fontName];

    // 如果字体不存在，则启用备用字体
    // 将字符串转换成几何形状
    let shapes = font.generateShapes(text, 12);

    let baseVertexes = [];
    let baseVertexesR = [];

    let contourList = [];
    let holeList = [];

    for (let i = 0; i < shapes.length; i++) {
        // 形状转多边形
        let shapePoints = shapes[i].extractPoints(12);
        // 外围包裹
        let contour = shapePoints.shape;
        // 内部孔洞
        let holes = shapePoints.holes;

        // 计算上下表面：这是二维的
        let faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let vertices = contour.slice();
        for (let h = 0, hl = holes.length; h < hl; h++) {
            vertices = vertices.concat(holes[h]);
        }

        for (let f = 0, fl = faces.length; f < fl; f++) {
            let face = faces[f];
            baseVertexes.push(
                vertices[face[0]].x, vertices[face[0]].y, 0,
                vertices[face[1]].x, vertices[face[1]].y, 0,
                vertices[face[2]].x, vertices[face[2]].y, 0
            );
            baseVertexesR.push(
                vertices[face[0]].x, vertices[face[0]].y, 0,
                vertices[face[2]].x, vertices[face[2]].y, 0,
                vertices[face[1]].x, vertices[face[1]].y, 0
            );
        }

        contourList.push(contour);
        holeList.push(...holes);
    }

    let box = new THREE.Box2();
    for (let c of contourList) {
        for (let p of c) {
            box.expandByPoint(p);
        }
    }

    return {
        box,
        baseVertexes,
        baseVertexesR,
        contourList,
        holeList
    }
}

function makeGeomFromVertexes(vertexes) {
    let geom = new THREE.BufferGeometry();
    geom.setAttribute("position", new THREE.BufferAttribute(new Float32Array(vertexes), 3));
    geom.computeVertexNormals();
    return geom;
}

// 绕轴旋转多边形
function addRotatePoly2(data, rotateAngle, scale) {
    let vertexes = [];
    let shiftY = - data.box.min.y + 2;
    let N = Math.ceil(rotateAngle / 0.03);
    for (let c of data.contourList) {
        c.reverse();
        let c1 = c.map(p => new THREE.Vector3(p.x, p.y + shiftY, 0));
        for (let i = 1, s = rotateAngle / N; i <= N; i++) {
            let angle = i * s;
            let m = new THREE.Matrix4();
            m.makeRotationX(angle);

            let c2 = c.map(p => new THREE.Vector3(p.x, p.y + shiftY, 0).applyMatrix4(m));
            addBound(vertexes, c1, c2);
            c1 = c2;
        }
    }

    for (let c of data.holeList) {
        c.reverse();
        let c1 = c.map(p => new THREE.Vector3(p.x, p.y + shiftY, 0));
        for (let i = 1, s = rotateAngle / N; i <= N; i++) {
            let angle = i * s;
            let m = new THREE.Matrix4();
            m.makeRotationX(angle);

            let c2 = c.map(p => new THREE.Vector3(p.x, p.y + shiftY, 0).applyMatrix4(m));
            addBound(vertexes, c1, c2);
            c1 = c2;
        }
    }

    let m1 = new THREE.Matrix4();
    m1.makeRotationX(rotateAngle);
    for (let i = 0; i < data.baseVertexes.length; i += 3) {
        let p = new THREE.Vector3(data.baseVertexes[i], data.baseVertexes[i + 1] + shiftY, data.baseVertexes[i + 2]);
        p.applyMatrix4(m1);
        vertexes.push(p.x, p.y, p.z);
    }
    for (let i = 0; i < data.baseVertexesR.length; i += 3) {
        vertexes.push(data.baseVertexes[i], data.baseVertexes[i + 1] + shiftY, data.baseVertexes[i + 2]);
    }

    // vertexes = [];
    const padding = 2;
    const thickness = 1.2 / scale;
    // 多加个一个底座。底座比字体多一个padding大小。
    addBox(vertexes, data.box.min.x - padding, data.box.max.x + padding, data.box.min.y + shiftY - padding, data.box.max.y + shiftY + padding, - thickness, 0);

    return makeGeomFromVertexes(vertexes);
}

function addBox(vertexes, x1, x2, y1, y2, z1, z2) {
    let a1 = new THREE.Vector3(x1, y1, z1);
    let b1 = new THREE.Vector3(x2, y1, z1);
    let c1 = new THREE.Vector3(x2, y2, z1);
    let d1 = new THREE.Vector3(x1, y2, z1);

    let a2 = new THREE.Vector3(x1, y1, z2);
    let b2 = new THREE.Vector3(x2, y1, z2);
    let c2 = new THREE.Vector3(x2, y2, z2);
    let d2 = new THREE.Vector3(x1, y2, z2);

    addRect(vertexes, d1, c1, b1, a1);
    addRect(vertexes, a2, b2, c2, d2);
    addBound(vertexes, [a1, b1, c1, d1], [a2, b2, c2, d2]);
}


// 两个多边形之间的壁
function addBound(vertexes, poly1, poly2) {
    let v2_1 = poly1[poly1.length - 1];
    let v2_2 = poly2[poly2.length - 1];
    for (let i = 0; i < poly1.length; i++) {
        let v1_1 = poly1[i];
        let v1_2 = poly2[i];
        addRect(vertexes, v2_1, v1_1, v1_2, v2_2);

        v2_1 = v1_1;
        v2_2 = v1_2;
    }
}

// 将一个矩形转换为两个三角形
function addRect(vertexes, a, b, c, d) {
    addTriangle(vertexes, a, b, c);
    addTriangle(vertexes, a, c, d);
}

// 将一个三角形加入顶点数组
function addTriangle(vertexes, a, b, c) {
    vertexes.push(a.x, a.y, a.z, b.x, b.y, b.z, c.x, c.y, c.z);
}






// WEBPACK FOOTER //
// ./src/views/word3d/scripts/initThree.js